import { defineStore } from 'pinia/dist/pinia';
import http from '@/store/helpers/http-common';

export const useCustomerUploadsStore = defineStore('customer-uploads', {
  state: () => ({
    customerUploads: [],
    uploadsMeta: {}
  }),
  actions: {
    async uploadCustomerDesigns(formData) {
      const { data } = await http.post('/customer_image', formData);

      if (data.files.length > 0) {
        data.files.forEach(e => {
          this.customerUploads.push(e);
          this.uploadsMeta[e.srcFile] = e.meta;
        });
      }

      return data.errors;
    },
    getMetaData(srcFile) {
      if (Object.prototype.hasOwnProperty.call(this.uploadsMeta, srcFile)) {
        return this.uploadsMeta[srcFile];
      }
      return null;
    },
    async loadMetaData(srcFile) {
      if (Object.prototype.hasOwnProperty.call(this.uploadsMeta, srcFile)) {
        return;
      }

      const { data, status } = await http.get(
        `/customer_image/meta/${srcFile}`
      );
      if (status !== 200) {
        this.uploadsMeta[srcFile] = null;
        return;
      }

      this.uploadsMeta[srcFile] = data.data;
    }
  },
  persist: true
});
